query GetCustomFieldStagesets {
    stagesets {
        id
        name
        customFields {
            shown {
                position
                customField {
                    id
                    attribute {
                        displayName
                        displayType
                        description
                    }
                    customFieldStats {
                        numOfForms
                    }
                }
            }
            hidden {
                id
                attribute {
                    displayName
                    displayType
                    description
                }
                customFieldStats {
                    numOfForms
                }
            }
        }
    }
}
